/**
 * Colour scheme for the drawer's drop targets.
 *
 * Each destination gets its own colour so a unit's row visibly carries where it
 * is headed. These are categorical identity colours (like chart series), not
 * theme surfaces — the surrounding chrome uses semantic tokens.
 */

/** The production itself — Hollywood Trucks green. */
export const PARENT_GROUP_COLOR = '#8FB560';

/** Sites, assigned by position under the selected production. */
export const SITE_COLORS = ['#3b82f6', '#a855f7', '#22d3ee', '#eab308', '#f97316'];

export function siteColorAt(index: number): string {
  return SITE_COLORS[index % SITE_COLORS.length];
}

/** Translucent wash of a hex colour, for fills and borders. */
export function tint(hex: string, alpha: number): string {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${alpha})`;
}
